<div class="grid-row">
  <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
    <legend class="usa-legend usa-legend--medium">
      FRT Template
    </legend>
  </div>
</div>
<form [formGroup]="frtTemplateForm">
  <div class="grid-row grid-gap-1">
    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
      <label class="usa-label" for="agency_id">SRO ID</label>
      <select id="agency_id" class="usa-select maxw-fulll" formControlName="sroId" [(ngModel)]="sroId">
        <option [ngValue]="0" selected disabled>Choose...</option>
        @for (sro of sroIdList; track sro) {
          <option [value]="sro.sroMasterId">{{sro.sroId}}
          </option>
        }
      </select>
    </div>
    @if (ofmSro) {
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
        <label class="usa-label" for="vehicle_class">Vehicle Class (Vehicle class must be selected):</label>
        <select id="vehicle_class" formControlName="vehicleClass" class="usa-select maxw-full" (change)="vehicleClassChange($event.target.value)">
          <option [ngValue]="0" selected disabled>Choose...</option>
          @for (vehicleClass of vehicleClassList; track vehicleClass) {
            <option [value]="vehicleClass.Value">{{vehicleClass.Text}}
            </option>
          }
        </select>
      </div>
    }
    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12 padding-top-4">
      <button type="button" [disabled]="sroId === 0" class="usa-button" (click)="getFrtFile()">Download Template</button>
    </div>
  </div>
</form>